<template>
  <div class="periodicalsDetail" id="waterContentId" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="page_news_title">
      <div class="site_width">
        <BookImg ref="vbookImg"></BookImg>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import BookImg from "@/components/BookImg.vue"
  import { removeWatermark, setWaterMark } from '@/assets/js/watermark.js'
  export default {
    name: "periodicalsDetail",
    components: {
      BookImg
    },
    data() {
      return {
        tableData: {},
        params: {
          id: 0
        },
        routeParams: {
          id: 0,
          columnId: 0,
          columnName: '首页',
          fromLikeSearch: false,
          parentId: 0
        }
      }
    },
    mounted() {
      if (!(window.sessionStorage.getItem('routeParams') == null || window.sessionStorage.getItem('routeParams') == undefined)){
        this.routeParams = JSON.parse(window.sessionStorage.getItem('routeParams'))
      }
      if (this.$route.params.id) {
        this.params.id = this.$route.params.id
        if (this.$route.params.fromLikeSearch) {
          this.routeParams.fromLikeSearch = true
        }
      } else if (this.$route.params.id == 0){
        this.params.id = 0
      }
      // 第一次初始化组件时，要调用函数进行获取id并查找数据
      this.getRportById ()
    },
    destroyed() {
      removeWatermark()
    },
    methods: {
      getRportById () {
        this.$refs.vbookImg.params.id = this.params.id
        this.$refs.vbookImg.getRportById()
        this.$refs.vbookImg.pageNum = 0
      },
      contentReturn() {
        this.$router.back()
      },
      formatDate(date) {
          if(date == undefined){
          return ''
        }
          return this.$moment(date).format("YYYY-MM-DD")
      }
    }
  }
</script>
<style scoped>
  .print_statue {
    display: none;
  }
  .site_width {
    max-width: 100%;
  }
</style>